import {
  type TeamMemberQueries,
  defTeamMemberQueries,
} from '@kizen/query/team-member';
import AxiosService from '__services/AxiosService';

const queries: TeamMemberQueries = defTeamMemberQueries(AxiosService);

export const teamMembersQuery: TeamMemberQueries['teamMembersQuery'] =
  queries.teamMembersQuery;

export const searchTeamMembersQuery: TeamMemberQueries['searchTeamMembersQuery'] =
  queries.searchTeamMembersQuery;
